import React from 'react';
import { Hero } from '../components/HeroCarousel';
import { QuickAccess } from '../components/QuickAccess';
import { News } from '../components/News';
import { Events } from '../components/Events';
interface AccueilProps {
  showEvents?: boolean;
}
export function Accueil({
  showEvents = true
}: AccueilProps) {
  return <main data-id="element-1853" data-mp="s2g628wqc21d">
      <Hero data-id="element-1854" data-mp="s2px7ztigf8n" />
      <QuickAccess data-id="element-1855" data-mp="s2zft2c87k4b" />
      <News data-id="element-1856" data-mp="n44w7y6fprj5" />
      {showEvents && <Events data-id="element-1857" data-mp="n4enrq74o6qy" />}
    </main>;
}